import { fg } from '@atlaskit/platform-feature-flags/fg';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';

/**
 * Jira Software Standard sites that are at or over their attachment storage allowance (JSSHL,
 * TAIYO-388).
 *
 * Sibling of `isEligibleForStorageHardLimit`, which is Free-only and fully rolled out. This one
 * deliberately reads no entitlement-derived field (`canUpgrade`, `canDirectBuyUpgrade`,
 * `BILLING_ADMIN`, `isInCollection`): a paid, non-trialling Standard tenant resolves a null
 * entitlement under the root query's filter, so those are never available here. Collection
 * membership is resolved separately by `JiraStandardStorageHardLimit` in the Standard dispatch,
 * which excludes collection sites.
 *
 * Does not fire exposure. The experiment cohort is read where the dialog is dispatched.
 */
export function isEligibleForJiraStandardStorageHardLimit(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInPredunning,
		storageUsageInGB,
		storageLimitInGB,
		storageIsUnlimited,
	} = context;

	if (!storageUsageInGB || !storageLimitInGB) {
		return false;
	}

	return Boolean(
		product === 'jira' &&
		isEditionOneOf(edition, ['standard']) &&
		!isInTrial &&
		!isInPredunning &&
		!storageIsUnlimited &&
		storageUsageInGB >= storageLimitInGB &&
		fg('jira-standard-storage-hard-limits-kill-switch'),
	);
}
